import api from './api';

// Service pour les commandes
export const ordersService = {
  // Récupérer toutes les commandes de l'utilisateur connecté
  getUserOrders: (page = 1, limit = 10, search = '') => {
    const params = new URLSearchParams({ page, limit });
    if (search) params.append('search', search);
    return api.get(`/api/orders?${params.toString()}`);
  },

  // Récupérer une commande par ID
  getOrderById: (orderId) => {
    return api.get(`/api/orders/${orderId}`);
  },

  // Créer une nouvelle commande
  createOrder: (orderData) => {
    return api.post('/api/orders', orderData);
  },

  // Annuler une commande
  cancelOrder: (orderId) => {
    return api.post(`/api/orders/${orderId}/cancel`);
  },

  // Mettre à jour le statut d'une commande (admin uniquement)
  updateOrderStatus: (orderId, status) => {
    return api.put(`/api/orders/${orderId}/status`, { status });
  },

  // Générer une étiquette Colissimo pour une commande
  generateLabel: async (orderId) => {
    const response = await api.post(`/api/admin/orders/${orderId}/generate-label`);
    return response.data;
  },

  // Générer une étiquette RETOUR (payload: { fullReturn: true } ou { fullReturn: false, orderItemIds: number[] })
  generateReturnLabel: async (orderId, payload = { fullReturn: true }) => {
    const response = await api.post(`/api/admin/orders/${orderId}/generate-return-label`, payload);
    return response.data;
  },

  // Télécharger une étiquette générée (optionnel: shipmentId pour une étiquette précise, ex: retour)
  downloadLabel: async (orderId, shipmentId) => {
    const params = shipmentId ? { shipmentId } : {};
    const response = await api.get(`/api/admin/orders/${orderId}/download-label`, {
      responseType: 'blob',
      params,
    });
    return response.data;
  },

  // Récupérer les expéditions
  getShipments: async (orderId) => {
    const response = await api.get(`/api/admin/orders/${orderId}/shipments`);
    return response.data;
  },

  // Suivre un colis
  trackParcel: async (orderId) => {
    const response = await api.get(`/api/admin/orders/${orderId}/track`);
    return response.data;
  },

  // Télécharger la facture PDF d'une commande
  downloadInvoice: async (orderId) => {
    const response = await api.get(`/api/orders/${orderId}/invoice`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Récupérer toutes les commandes (admin uniquement)
  getAllOrders: (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (filters.status) params.append('status', filters.status);
    if (filters.userId) params.append('userId', filters.userId);
    if (filters.search) params.append('search', filters.search);
    return api.get(`/api/admin/orders?${params.toString()}`);
  },

  // Créer une commande manuellement (admin uniquement - pour vente directe)
  createManualOrder: (orderData) => {
    return api.post('/api/admin/orders/manual', orderData);
  },

  // Supprimer une commande (admin uniquement) — supprime la commande et ses lignes
  deleteOrder: (orderId) => {
    return api.delete(`/api/admin/orders/${orderId}`);
  },

  // Supprimer plusieurs commandes (admin uniquement)
  deleteOrdersBulk: (ids) => {
    return api.post('/api/admin/orders/delete-bulk', { ids });
  },
};

export default ordersService;







